import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const StaffIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 12;
  const color = props.color || '#ff8f13';
  return <Icon name={'staff'} size={size} color={color} />;
};

export default React.memo(StaffIcon);
